/**
 * EventBus based on EventTarget and set to window for match-search
 */
const eventBus = window.EventBus ? window.EventBus : new EventTarget();

window.EventBus = eventBus;

export { eventBus };
